






//import { ResponseModel } from "@dataSource/models/responseModels.ts";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({ name: "ui-box-menu" })
export default class UiBoxMenuComponent extends Vue {
  @Prop({ default: "", type: String })
  position: string; // left centre right

  @Prop({ default: false, type: Boolean })
  shadow: boolean; // left centre right

  getPosition(): string {
    if (this.position == "left") return "left";
    if (this.position == "right") return "right";
    if (this.position == "centre") return "centre";
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-box-menu/src/ui-box-menu.vue